//#region src/variants/variants_presence.js
var variants_presence_default = {
	defaults: { props: { presence: { tokenCategory: "color:d-presence--:--presence-color-background-" } } },
	default: { props: { presence: { initialValue: "active" } } },
	busy: { props: { presence: { initialValue: "busy" } } },
	away: { props: { presence: { initialValue: "away" } } },
	offline: { props: { presence: { initialValue: "offline" } } }
};
//#endregion
export { variants_presence_default as default };

//# sourceMappingURL=variants_presence.js.map